import { render } from "./shinsei_Karibaraiedit.vue?vue&type=template&id=e8ad71b6&ts=true"
import script from "./shinsei_Karibaraiedit.vue?vue&type=script&lang=ts"
export * from "./shinsei_Karibaraiedit.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__